export enum EnumMimeType {
    ALL = '*',
    EXCEL = 'application/vnd.ms-excel',
    EXCEL_OPEN_XML = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    JPG = 'image/jpeg',
    JPEG = 'image/jpeg',
    MP4 = 'video/mp4',
    MPEG = 'video/mpeg',
    PDF = 'application/pdf',
    PNG = 'image/png',
    POWERPOINT = 'application/vnd.ms-powerpoint',
    POWERPOINT_OPEN_XML = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    WEBM = 'video/webm',
    WORD = 'application/msword',
    WORD_OPEN_XML = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
}
